"use client"

import { Radical } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RadicalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RadicalIcon = component(Icon)({ as: Radical })
